import { useEVChargerStore } from '../../../../hooks/useEVChargerStore';

export const SelectedLocationTextContent = () => {
  const {
    data: { serviceLocationDetails, assetDetails, provider },
  } = useEVChargerStore();

  const isSiteName = assetDetails?.site_name !== undefined;
  const isProvider = provider === 'ShellUbitricity';
  const isEVCharger =
    assetDetails?.feature_type_code === 'PLEV' &&
    assetDetails?.central_asset_id !== undefined;

  return (
    serviceLocationDetails.full_address && (
      <div className="text-bodyXl mt-4 flex flex-col gap-[1.25rem]">
        <p className="font-semibold text-black">{`Nearest address to the EV charging point`}</p>
        <p className="font-normal text-black">
          {isProvider && isSiteName
            ? assetDetails.site_name
            : serviceLocationDetails.full_address}
        </p>

        {isProvider && (
          <>
            <p className="font-semibold text-black">{`EV charging point`}</p>
            <p className="font-normal text-black">
              {isEVCharger
                ? `EV charging point selected`
                : `No EV charging point selected`}
            </p>
          </>
        )}
      </div>
    )
  );
};
